import script from "./UploadDocumentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadDocumentModal.vue?vue&type=script&setup=true&lang=js"

import "./UploadDocumentModal.vue?vue&type=style&index=0&id=1c4319b5&scoped=true&lang=css"
import "./UploadDocumentModal.vue?vue&type=style&index=1&id=1c4319b5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c4319b5"]])

export default __exports__